import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Field } from '@ahmdigital/ui';
import React from 'react';

import { RootState } from '../../reducers';
import CustomerActions from '../../actions/customer';
import hospitalExcessToOptions from '../../utils/hospital-excess-to-options';
import selectCustomer from '../../selectors/select-customer';
import selectExcessToggleValues, { ExcessToggleValues } from '../../selectors/select-excess-toggle-values/index';

type HospitalExcessToggleProps = {
  actions: {
    customer: {
      changeHospitalExcess: (...args: unknown[]) => unknown;
    };
  };
  customerExcess: string;
  hospitalExcess: ExcessToggleValues;
  isRequired?: boolean;
};

const HospitalExcessToggle = ({ actions, customerExcess, hospitalExcess, isRequired }: HospitalExcessToggleProps) => (
  <Field
    hasContainerID
    inputVariant={['button']}
    isRequired={isRequired}
    name="Hospital excess change"
    onChange={actions.customer.changeHospitalExcess}
    options={hospitalExcessToOptions(hospitalExcess)}
    size="auto"
    type="radioGroup"
    value={customerExcess}
  />
);

HospitalExcessToggle.defaultProps = {
  isRequired: false,
};

const mapStateToProps = (state: RootState) => ({
  customerExcess: selectCustomer(state).hospitalExcess,
  hospitalExcess: selectExcessToggleValues(state),
});

// @ts-expect-error - Automatic, Please fix when editing this file
const mapDispatchToProps = (dispatch) => ({
  actions: {
    customer: bindActionCreators(CustomerActions, dispatch),
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(HospitalExcessToggle);

export { HospitalExcessToggle as HospitalExcessToggleForTest };
